import {delegate} from './tools';
import './catalog';


const header = document.querySelector('.navHeader');
const headerSpacer = document.querySelector('.navHeaderSpacer');
let animationEnabled = false;



document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        animationEnabled = true;

    }, 100)
});

const handler = (entries) => {
    if (!entries[0].isIntersecting) {
        if(animationEnabled === true){
            header.classList.add('--animation');
        }
        header.classList.add('--sticky');
        if(animationEnabled === true) {
                header.addEventListener('transitionend', function animationEnd(){
                    header.classList.remove('--animation');
                    header.removeEventListener('transitionend', animationEnd)
                });
            } 

    } else {
        if(header.classList.contains('--sticky')){
            if(animationEnabled === true){
                header.classList.add('--animation');
            }
            if(animationEnabled === true) {
                header.addEventListener('transitionend', function animationEnd(){
                    header.classList.remove('--animation');
                    header.removeEventListener('transitionend', animationEnd)
                });
            } 
        }
        header.classList.remove('--sticky');
        
    }
}

const observer = new window.IntersectionObserver(handler);
observer.observe(headerSpacer);



// menu open 

const menuButton = document.querySelector('.navHeader__button');
const anchorLinks = document.querySelectorAll('.nav__link--anchor');
const nav = document.querySelector('.navHeader__nav');


menuButton.addEventListener('click', (event) => {
    if(header.classList.contains('--open')){
        if(animationEnabled === true){
            header.classList.add('--animation');
        }
        header.classList.remove('--open');
        document.body.classList.remove('menu-open')
        if(animationEnabled === true) {
            header.addEventListener('transitionend', function animationEnd(){
                header.classList.remove('--animation');
                header.removeEventListener('transitionend', animationEnd)
            });
        } 
    } else {
        if(animationEnabled) {
            header.classList.add('--animation');
        }        header.classList.add('--open');
        nav.scrollTop = 0;
        document.body.classList.add('menu-open');
        if(animationEnabled) {
            header.addEventListener('transitionend', function animationEnd(){
                header.classList.remove('--animation');
                header.removeEventListener('transitionend', animationEnd)
            });
        }
    }
});

anchorLinks.forEach((anchorLink) => {
    anchorLink.addEventListener('click', () => {
        header.classList.remove('--open');
        document.body.classList.remove('menu-open')
        header.addEventListener('transitionend', function animationEnd(){
            header.classList.remove('--animation');
            header.removeEventListener('transitionend', animationEnd)
        })
    })
})


// images block 

resizeImagesBlock();
function resizeImagesBlock(){
    const imagesBlocks = document.querySelectorAll('.images');

    if(imagesBlocks.length > 0){
        imagesBlocks.forEach((imagesBlock) => {
            const images = imagesBlock.querySelectorAll('.images__listitem');

            if(images.length > 0){
                const width = images[0].getBoundingClientRect().width;
                const half = Math.ceil(images.length/2);
                let height1 = 0;
                let height2 = 0;
                for(let i = 0; i < half; i++){
                    height1 = height1 + width/images[i].dataset.ratio + 70;
                    console.log(height1);

                }
                for(let i = half; i < images.length; i++){
                    
                    height2 = height2 + width/images[i].dataset.ratio + 70;
                    console.log(width, height2);
                }
                console.log( Math.max(height1, height2) + 'px')
                imagesBlock.style.height = Math.max(height1, height2) + 'px';
            }
        });
    }
}


// Pattern stripe

const patternStrip = document.querySelector('.patternStrip');
if(patternStrip){
    fillPatternStrip();
}
function fillPatternStrip(){
    const width = patternStrip.getBoundingClientRect().width;
    const height = patternStrip.getBoundingClientRect().height;
    for(let i = 0; i < Math.ceil(height/width); i++){
        patternStrip.innerHTML += `
            <div class="patternStrip__form form form--${getRandomInt(1, 6)} form--r${getRandomInt(0, 3)*90}"></div> 
        `;
    }
    console.log(width, height, Math.ceil(height/width))
}
function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
}

